<template>
  <div class="h-100">
    <common ref="common" />
    <template v-if="pymtDetails.tracking_id!=null">
      <PaymentSuccess
        v-if="$route.name == 'PaymentSucess'"
        :pymtDetails="pymtDetails"
      />
    </template>
    <PaymentFailed v-if="$route.name == 'PaymentFailed'"  /> 
    <!-- <template v-else>
      //:pymtDetails="pymtDetails"
      <PaymentFailed
        :message = "Details Not Found"
      />
      <PaymentFailed v-if="$route.name == 'PaymentFailed'" />
    </template> -->
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import PaymentSuccess from "@/components/wesupport/payment/PaymentSuccess.vue";
import PaymentFailed from "@/components/wesupport/payment/PaymentFailed.vue";

export default {
  components: {
    common: () => import("@/components/tools/common.vue"),
    PaymentSuccess,
    PaymentFailed,
  },
  data: () => ({
    pymtDetails: {},
  }),
  mounted() {
    this.$emit("changeHeader", "Payment Status");
    this.getPymtDetails();
  },
  methods: {
    getPymtDetails() {
      // console.log("getPymtDetails",this.$route.params.id);
      if(this.$route.params.id!==undefined)
      {
      let url = `/api/wesupport/payment/GetPaymentResponse?orderId=${this.$route.params.id}`;
      callApi(url, "post", "")
        .then((res) => {
          this.pymtDetails = res.data.data;
        })
        .catch((err) => {
          this.$refs.common.ManageResponse(err.response);
        });
      }
    },
  },
};
</script>
